import { gql } from '@apollo/client'

export const CREATE_BOOKING_NIGHTLY = gql`
    mutation BookingCreateBookingNightly(
        $email: String!
        $plates: [InputBookingPlate!]
        $lot_id: String!
        $total_amount: numeric!
        $shopper_locale: String!
        $start_datetime: timestamptz!
        $end_datetime: timestamptz!
        $night_parking_config: [NightParkingConfig]!
    ) {
        create_night_parking_booking(
            email: $email
            plates: $plates
            lot_id: $lot_id
            total_amount: $total_amount
            shopper_locale: $shopper_locale
            start_datetime: $start_datetime
            end_datetime: $end_datetime
            night_parking_config: $night_parking_config
        ) {
            id
            booking_reference
            success
            unavailable_dates
        }
    }
`

// NightParkingConfig
// rrule: str
// iso_duration:str
